<template>
  <div class="modal" v-if="open" :class="M_mode === 'video' ? 'wider' : ''">
    <div
      class="modal-backdrop"
      ref="backdrop"
      @click.self="closeHandler(true)"
    ></div>

    <div class="modal-wrapper" ref="wrapper" >
      <div class="modal-header">
        <i class="icon icon-close" @click="closeHandler(true)"></i>
        <h3>{{ title }}</h3>
      </div>
      <div class="modal-body">
        <div class="body-wrapper">
          <!-- 用户登录 -->
          <template v-if="M_mode === 'login'">
            <input
              v-model="phone"
              type="number"
              class="input"
              placeholder="用户名/电话号码"
            />
            <input
              v-model="password"
              @keyup.enter="login()"
              type="password"
              class="input"
              placeholder="密码"
            />
            <button class="button" @click="login()">立即登录</button>
            <div class="buttons">
              <!-- <button class="btn">忘记密码</button> -->
              <button class="btn" @click="M_mode = 'register'">
                新用户注册
              </button>
            </div>
          </template>
          <!-- 用户登录 -->

          <!-- 用户注册 -->
          <template v-else-if="M_mode === 'register'">
            <input
              v-model="phone"
              type="number"
              class="input"
              placeholder="用户名/电话号码"
            />
            <div
              class="validation input-group"
              :class="{ active: phoneValid && canSend }"
            >
              <input type="number" class="verify input" v-model="verifyCode" />
              <div class="span" @click="sendVerifyCode">
                <span v-show="canSend">发送验证码</span>
                <span v-show="!canSend">{{ resendCodeTime }}秒后发送</span>
              </div>
            </div>
            <input
              v-model="password"
              type="password"
              class="input"
              placeholder="设置密码"
            />
            <input
              v-model="password2"
              type="password"
              class="input"
              placeholder="确认密码"
            />
            <input
              v-model="nickname"
              type="text"
              class="input"
              placeholder="用户昵称"
            />
            <input
              v-model="referee"
              type="text"
              class="input"
              placeholder="推荐码（选填）"
            />
            <button class="button" @click="register()" :disabled="!canRegister">
              立即注册
            </button>
            <div class="buttons">
              <!-- <button class="btn">忘记密码</button> -->
              <button class="btn" @click="M_mode = 'login'">返回登录</button>
            </div>
          </template>
          <!-- 用户注册 -->

          <!-- 用户信息 -->
          <template v-else-if="M_mode === 'userInfo'">
            <div class="row">
              <span class="left">头像</span>
              <div class="right avatar">
                <span v-show="!userAvatar || useTextImg">{{
                  userInfo.nickname.substr(0, 1).toUpperCase()
                }}</span>
                <img
                  v-show="userAvatar"
                  :onerror="(useTextImg = true)"
                  :src="userAvatar"
                  alt="用户头像"
                />
              </div>
            </div>
            <div class="row">
              <span class="left">{{
                userInfo.name ? "真实姓名" : "昵称"
              }}</span>
              <div class="right">
                <span>{{ userInfo.name || userInfo.nickname }}</span>
              </div>
            </div>

            <div class="row">
              <span class="left">电话号码</span>
              <div class="right">
                <span>{{ userInfo.phone }}</span>
              </div>
            </div>
            <div class="row">
              <span class="left">公司</span>
              <div class="right">
                <span>{{ userInfo.company || "" }}</span>
              </div>
            </div>
            <div class="row">
              <span class="left">认证状态</span>
              <div class="right">
                <span>{{ authStatus }}</span>
              </div>
            </div>
            <div class="row">
              <span class="left">我的推荐码</span>
              <div class="right">
                <span>{{ userInfo.refCode }}</span>
              </div>
            </div>
          </template>
          <!-- 用户信息 -->

          <template v-else>
            <video
              :src="videoSrc"
              controls
              autoplay
              width="880"
              height="490"
            ></video>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
import cookie from '@/utils/cookie';
import eventBus from '@/utils/eventBus';
import validator from '@/utils/validator';
import utils from '@/utils/utils';

export default {
  name: 'headera',
  data() {
    return {
      phone: '',
      password: '',
      password2: '',
      referee: '', // 推荐码
      nickname:'',//用户昵称
      loginedUser: null,
      verifyCode: '', // 验证码
      resendCodeTime: 120,
      resendCodeTimer: null,
      canSend: true,
      useTextImg: false,
      M_mode: this.mode
    }
  },
  props: {
    open: Boolean,
    mode: {
      type: String,
      default: 'login' // 'login' 登陆模态框； 'register': 注册 ;   'userInfo' 用户信息;  'video'
    },
    userInfo: Object,
    videoSrc: String
  },
  created(){
  },
  methods: {
    closeHandler(canceled = false) {
      this.$refs.backdrop.style.background = 'rgba(0,0,0,0)';
      this.$refs.wrapper.style.opacity = '0';
      document.body.style.overflow = '';
      setTimeout(() => {
        this.$emit('update:open', false);
        canceled && this.$emit('canceled');
      }, 500);
    },

    /**
     * 登录方法
     */
    login() {
      this.$http.post('/shipper/login-app', this.$utils.postUrlDeal({
        phone: this.phone,
        password: this.password,
        type: 'shipper'
      })).then(res => {
        // 将cookie保存两小时
        let data = res.data
        cookie.setCookie(`${data.nickname}:${data.type}`, JSON.stringify(data), 2);
        sessionStorage.setItem('user', `${data.nickname}:${data.type}`);
        this.loginedUser = data;
        localStorage.setItem('userInfo', JSON.stringify(data))
        eventBus.emit('login', this.loginedUser);

        this.$message({
          type: 'success',
          message: '登录成功!'
        });

        this.$router.push({
          name: 'order'
        });
        sessionStorage.setItem('token',data.accessToken)
        this.closeHandler();
      }).catch(err => {
        this.$alert(err.message, '登录失败', {
          confirmButtonText: '确定'
        });
        console.error(err)
      })
    },

    /**
     * 发送验证码
     */
    sendVerifyCode() {
      if (!this.phone || !this.canSend) return;
      if (!validator.mobile(this.phone)) {
        this.$prompt('请输入正确的手机号码', '提示');
        return;
      }
      this.$http.get('/shipper/site/send-verify-code', {
        params: {
          phone: this.phone
        }
      }).then(() => {
        this.canSend = false;
        this.resendCodeTimer = setInterval(() => {
          if (this.resendCodeTime <= 0) {
            clearInterval(this.resendCodeTimer);
            this.resendCodeTime = 120;
            this.canSend = true;
          }
          this.resendCodeTime--;
        }, 1000);
      }).catch(err => {
        this.$message.error('验证码发送失败，' + err.message);
      })
    },

    /**
     * 用户注册
     */
    register() {
      this.$http.post('/shipper/register', this.$utils.postUrlDeal({
        phone: this.phone,
        password: this.password,
        type: 'shipper',
        role: 'person',
        myReferee: this.referee,
        verifyCode:this.verifyCode,
        nickname:this.nickname,
      })).then(data => {
        this.M_mode = 'login';
      }).catch(err => this.$alert(err.message, '注册失败', {
        confirmButtonText: '确定'
      }));
    }
  },
  computed: {
    phoneValid() {
      return this.canSend && validator.mobile(this.phone);
    },
    canRegister() {
      return this.verifyCode.length === 6 && this.password.length >= 6 && (this.password === this.password2) && this.nickname;
    },
    userAvatar() {
      return utils.getDomainUrl() + this.userInfo.avatar;
    },
    title() {
      if (this.M_mode === 'login') return '货主登录';
      if (this.M_mode === 'register') return '用户注册';
      if (this.M_mode === 'userInfo') return '用户信息';
      if (this.M_mode === 'video') return '查看视频';
    },
    authStatus() {
      switch (this.userInfo.authStatus) {
        case 0:
          return '未认证';
          break;
        case 1:
          return '认证中';
          break;
        case 2:
          return '已认证';
          break;
        case 3:
          return '认证失败';
          break;

        default:
          break;
      }
    }
  },

  watch: {
    open(newValue) {
      if (newValue == true) {
        this.password = '';
        document.body.style.overflow = 'hidden';
        setTimeout(() => {
          this.$refs.backdrop.style.background = 'rgba(0,0,0,0.6)';
          this.$refs.wrapper.style.opacity = '1';
        }, 10);
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
@import "../style/common/base";
@import "../style/_variable";

.modal {
  &.wider {
    .modal-header {
      max-width: 1000px;
      width: 50%;
      .icon::before {
        margin-left: 21%;
      }
    }
    .modal-body {
      max-width: 1000px;
      width: 50%;
    }
  }

  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 24px;
    overflow: hidden;
    background-color: $text-clr_primary;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 20px;
    font-weight: bold;
    span {
      color: white;
    }
  }

  text-align: center;
  &-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    background: rgba(0, 0, 0, 0);
    transition: all 0.5s;
  }

  &-wrapper {
    border-radius: 5px;
    position: fixed;
    top: 10%;
    width: 100%;
    z-index: 10;
    overflow: hidden;
    opacity: 0;
    transition: all 0.5s;
  }

  &-header {
    margin: auto;
    width: 350px;
    padding: 20px 0;
    background-color: $text-clr_primary;
    .icon-close:before {
      cursor: pointer;
      position: absolute;
      width: 18px;
      height: 18px;
      margin-left: 130px;
      background: url("../assets/images/page_index/close.png") center no-repeat;
    }
    h3 {
      text-align: center;
      color: white;
      font-size: 20px;
    }
  }
  &-body {
    margin: auto;
    width: 350px;
    background-color: #fff;
    padding: 40px 0;
    text-align: center;
    .body-wrapper {
      padding: 0 60px;

      .input-group {
        font-size: 14px;
        width: 100%;
        margin: 0 0 10px;
        height: 42px;
        border: 1px solid $border-clr;
        border-radius: 4px;
        outline: none;
        transition: all 0.5s;
        &:active,
        &:focus,
        &:hover {
          border-color: $text-clr_primary;
          box-shadow: 0 0 2px $text-clr_primary;
        }
        .input {
          margin: 0;
          height: 40px;
          border: $border-clr;
          &:active,
          &:focus,
          &:hover {
            border: $border-clr;
            box-shadow: none;
          }
        }
        .span {
          width: 80%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: not-allowed;
          background-color: $bg-clr_lighter;
          transition: background 0.5s;
          user-select: none;
          span {
            color: white;
          }
        }
        &.active {
          .span {
            background-color: $text-clr_primary;
            cursor: pointer;
            span {
              color: white;
            }
          }
        }
      }
      .input {
        font-size: 14px;
        width: 100%;
        margin: 0 0 10px;
        height: 42px;
        border: 1px solid $border-clr;
        border-radius: 4px;
        outline: none;
        padding: 0 10px;
        transition: all 0.5s;
        &:active,
        &:focus,
        &:hover {
          border-color: $text-clr_primary;
          box-shadow: 0 0 2px $text-clr_primary;
        }
      }
      .row {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
    .button {
      margin-top: 10px;
      width: 100%;
      background: $text-clr_primary;
      border: none;
      padding: 10px;
      color: white;
      border-radius: 2px;
      cursor: pointer;
      &[disabled] {
        background-color: $bg-clr;
        color: $text-clr_lighter;
        cursor: not-allowed;
      }
    }
    .buttons {
      overflow: hidden;
      margin-top: 20px;
      .btn {
        //   width: 100px;
        font-size: 14px;
        background-color: transparent;
        color: $text-clr;
        float: left;
        &:last-child {
          float: right;
          color: $text-clr_primary;
        }
      }
    }
    .validation {
      display: flex;
    }
    .row {
      width: 100%;
      height: 50px;
      border-bottom: 1px solid $border-clr;
      &:last-child {
        border: none;
      }
      .left {
        color: $text-clr_light;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal.vue